"use strict";
(function (global) {

/**
  * Фабрика задач.
  * Предоставлет инструменты для работы с задачами. Например, для создания новой задачи, поиска требуемой задачи.
  *
  * @namespace WebAccess.factories.tasks
  * @since 5.0.0.7300
  */

  /**
   * Параметры создаваемой задачи.
   *
 * @typedef {Object} WebAccess.factories.tasks.taskSettings
   * @property {String} [subject] Тема задачи
   * @property {String} [activeText] Текст задачи 
   * @property {Date} [deadline] Срок выполнения
   * @property {WA.Link} [parent] Родительский деловой процесс, например, главная задача или подзадача
   * @property {Array<WA.Link>} [attachments] Список вложений
   * @property {JOB_KIND} [jobsKind] Тип заданий
   * @property {Array<Integer>} [route] Список ИД исполнителей
   * @property {Array<Integer>} [observers] Список ИД наблюдателей 
   * @property {WORK_ACCESS_TYPE} [accessType] Тип доступа к деловому процессу
   * @property {WA.Link} [bindTo] Создание связи с объектом
   * @property {boolean} [autoSave] Сохранение задачи после ее создания
   * @property {boolean} [autoStart] Стартовать задачу после ее создания
 * @since 5.0.0.7300
 */

  var TasksFactory = global.factories.BaseFactory.extend({
    className: "TasksFactory",
    contentType: OBJECT_TYPE.TASK,
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//         

    init: function () {
      this._super(this.contentType);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//         

    /**
    * Получить задачу по ее ИД.
    *
    * @method WebAccess.factories.tasks.getTaskByID
    * @param {Integer} id ИД задачи
    * @param {MODEL} [opt_modelType] Тип возвращаемой модели данных
    * @return {deferred} Искомая задача.
    * @since 5.0.0.7300
    */
    getTaskByID: function (id, opt_modelType) {
      return this.getObjectByID(id, opt_modelType);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Создать новую задачу.
     *
     * @method WebAccess.factories.tasks.createTask
     * @param {number|Link|BaseObjectModel|TaskModel|JobModel|taskSetting}  opt_parent Родительский деловой процесс, например, главная задача или подзадача
     * @param {MODEL} [opt_modelType] Тип возвращаемой модели данных
     * @return {Deferred<Object>} Новая задача.
     * @see https://api.jquery.com/category/deferred-object/
     *
     * либо как подзадача указанного делового процесса.
     * @since 5.0.0.7300
     *
     * @example
     * // Создать новую задачу.
     * WA.FC.tasks.createTask().done(function (task) {
     *   task.open()
     * });
     *
     * @example
     * // Создать новую задачу и указать для нее родительскую задачу.
     * WA.FC.tasks.createTask(2189).done(function (task) {
     *   task.open()
     * });
     *
     * @example
     * // Создать подзадачу из задачи.
     * WA.FC.tasks.createTask(new WA.Link(2189, OBJECT_TYPE.TASK)).done(function (task) {
     *   task.open()
     * });
     *
     * @example
     * // Создать подзадачу из задания.
     * WA.FC.tasks.createTask(new WA.Link(65, OBJECT_TYPE.JOB)).done(function (task) {
     *  task.open()
     * });
     *
     * @example
     * // Создать родительское задание и заполнить его параметры.
     * var taskSettings = {
     *   subject: 'Задача, созданная фабрикой',
     *   activeText: 'Текст задачи',
     *   parent: new WA.Link(65, OBJECT_TYPE.JOB),
     *   attachments: [new WA.Link(65, OBJECT_TYPE.JOB)],
     *   route: [133311,132970],
     *   observers: [133311],
     *   accessType: WORK_ACCESS_TYPE.PARTICIPANTS,
     *   autoSave: true,
     *   autoStart: true
     * };
     *
     * WA.FC.tasks.createTask(taskSettings).done(function (task) {
     *   task.open()
     * });
     *
     * @example
     * // Создать подзадачу по ТМ и заполнить его параметры.
     * var taskSettings = {
     *   subject: 'Подзадача по ТМ для задания',
     *   activeText: 'Текст задачи',
     *   parent: new WA.Link(3064, OBJECT_TYPE.JOB),
     *   attachments: [new WA.Link(3012, OBJECT_TYPE.JOB)],
     *   standardRouteID: 140332, //либо по коду  standardRouteCode: "TST_PRM",
     *   observers: [133898],
     *   autoSave: false,
     *   autoStart: false
     * };
     *
     * WA.FC.tasks.createTask(taskSettings).done(function (task) {
     *   var link = new WA.Link(task.ID, OBJECT_TYPE.TASK);
     *   link.open();
     * });
     */
    createTask: function (opt_parent, opt_modelType) {
      var me = this;
      var params = {};
      var parentLink;
      opt_parent = opt_parent || 0;      

      var proxyCall = $.Deferred();
      opt_modelType = (!opt_modelType) ? MODEL.FULL : opt_modelType;
      if ($.isPlainObject(opt_parent)) {
        params = opt_parent;
        if (opt_parent.hasOwnProperty('parent')) {
          params.parent = opt_parent.parent.asString();
        }

        if (opt_parent.hasOwnProperty('deadLine')) {
          params.deadLine = $.toJSON(opt_parent.deadLine)
        }

        if (opt_parent.hasOwnProperty('attachments')) {
          for (var i = 0; i < opt_parent.attachments.length; i++) {
            opt_parent.attachments[i] = opt_parent.attachments[i].toLinkModel();
          }
          params.attachments = $.toJSON(opt_parent.attachments);
        }       
      } else {
        if (typeof opt_parent !== 'object' && !isNaN(opt_parent) && opt_parent > 0) {
          parentLink = new WA.Link(opt_parent, me.contentType);
        } else if (typeof opt_parent === 'object' && opt_parent.className === 'Link') {
          parentLink = opt_parent;
        } else if (typeof opt_parent === 'object' && !!opt_parent.className) {
          //Базовых объектов пока не очень существует, ничего нельзя гарантировать
          WA.raise('NOT_IMPLEMENTED_EXCEPTION')
        };

        if (!!parentLink) {
          params.parent = parentLink.asString();
        };
      };

      WA.SRV.call("/Factories.asmx/CreatePreConfiguredTask", { Params: params, Mode: opt_modelType }).done(function (model) {
        proxyCall.resolve(me._handleModel(model, opt_modelType));
      }).fail(function (error) {
        proxyCall.reject(error);
      });

      return proxyCall;
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//         

  });
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  global.factories.tasks = new TasksFactory();
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

})(window.WebAccess);
